/**
 * Derivaciones que usan las tres variantes del Overview. Están en un solo lugar
 * para que las tres calculen la base de un delta igual: si cada pantalla armara
 * la suya, en alguna el porcentaje quedaría comparado contra otro mes.
 */
import type { DeltaBase, MetricValue } from '@ops/contracts'
import { deltaBaseOf, periodoAnterior } from '@ops/contracts'

import type { Frente } from './frentes'

export function porSlug(
  metricas: readonly MetricValue[],
  slug: string,
): MetricValue | null {
  return metricas.find((m) => m.slug === slug) ?? null
}

/**
 * Base del delta: el período anterior y su valor, sacado del penúltimo punto del
 * sparkline. La regla de números derivables obliga a publicarla al lado del
 * porcentaje, así que ningún delta se renderiza sin pasar por acá.
 */
export function baseDe(metric: MetricValue): DeltaBase | null {
  const anterior = periodoAnterior(metric.periodo)
  return anterior === null ? null : deltaBaseOf(metric, anterior)
}

/** La métrica de un frente, cuando el frente es una métrica del tablero. */
export function metricaDelFrente(
  metricas: readonly MetricValue[],
  frente: Frente,
): MetricValue | null {
  return frente.entityType === 'metric'
    ? porSlug(metricas, frente.entityId)
    : null
}

export function baseDelFrente(
  metricas: readonly MetricValue[],
  frente: Frente,
): DeltaBase | null {
  const metric = metricaDelFrente(metricas, frente)
  return metric === null ? null : baseDe(metric)
}
